import {UserManager, WebStorageStateStore} from 'oidc-client-ts';

const {protocol, hostname, port} = window.location;
const baseUrl =  window.location.origin;

export const userManager = new UserManager({
    client_id: process.env.REACT_APP_OAUTH2_CLIENT_ID ?? '',
    redirect_uri: `${baseUrl}`,
    response_type: 'code',
    scope: 'openid profile offline_access',
    extraQueryParams: process.env.REACT_APP_OAUTH2_AUDIENCE ? {
        audience: process.env.REACT_APP_OAUTH2_AUDIENCE,
    } : undefined,
    authority: process.env.REACT_APP_OAUTH2_AUTHORITY ?? '',
    // silent_redirect_uri: `${baseUrl}/oidc/silent-callback`,
    post_logout_redirect_uri: `${baseUrl}/oidc/sign-out-callback`,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: false,
    userStore: new WebStorageStateStore({ store: sessionStorage})
});
